/**
 * PQR Common Styles
 * 
 * Centralized style definitions for PQR PDF components
 */

export const pqrStyles = {
  container: {
    display: "flex",
  },
  group: {
    display: "flex",
  },
  title3: {
    width: "50%",
  },
};

export const pqrTableClasses = {
  border: "PQR_border",
  noleft: "PQR_noleft", 
  right: "PQR_right",
  botm: "PQR_Botm",
  noTop: "PQR_noTop",
  rtLft: "PQR_rt_lft",
  botmrt: "PQR_Botmrt",
  noBotm: "PQR_noBotm"
};

export const pqrTableStyles = {
  mainTable: "PQRpwhtTable",
  table2: "PQRTable2", 
  fillerMetal: "PQRfillerMetalth"
};